import { createFileRoute } from "@tanstack/react-router"
import { meta } from "@/content"
import { AuthPage } from "@/app"

export const Route = createFileRoute("/$locale/auth/")({
  component: RouteComponent,
  validateSearch: (search) => search as { email?: string },
  head: () => ({ meta: meta({ title: "Sign in or sign up" }) }),
})

function RouteComponent() {
  const { email } = Route.useSearch()

  return <AuthPage email={email} />
}
